import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-ap-mishra',
  templateUrl: './ap-mishra.component.html',
  styleUrls: ['./ap-mishra.component.scss']
})
export class ApMishraComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getAPMishra();
  }
}
